/* eslint-disable no-shadow */
// should go through these at some point
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import React, { FC, useState, ChangeEvent, useEffect, useRef } from 'react'
import { inject, observer } from 'mobx-react'
import { FormControl as BootStrapFormControl } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import {
  Divider,
  Button,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuList,
  MenuItem,
  Select,
  FormGroup,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  TableRow,
  TablePagination,
} from '@material-ui/core'
import { FaFileExport, FaSearch, FaTimes, FaUserAlt } from 'react-icons/fa'
import API from '@aws-amplify/api'
import { CloseRounded } from '@material-ui/icons'
import 'react-datepicker/dist/react-datepicker.css'
import { ToastTypeEnum } from '../Toasts'
import { Search as SearchStore } from '../../../stores/search'
import { Prospects as ProspectsStore, Prospect } from '../../../stores/prospects'
import Spinner from '../../Spinner'
import ContactTable, { TablePaginationActions } from './ContactTable'
import CircleCheckbox from '../../CircleCheckbox'
import './styles.scss'
import BulkLeadActions from '../Common/BulkLeadActions'
import { ranks } from '../../../utils/constants'

type Order = 'asc' | 'desc'

interface Props extends RouteComponentProps {
  search?: SearchStore
  prospects?: ProspectsStore
  currentUser: any
  setCurrentUser: React.Dispatch<any>
  setTypeProp: React.Dispatch<React.SetStateAction<string>>
  SidebarExpanded: boolean
  setSidebarExpanded: any
}

export const assignManeuverList = [
  {
    name: 'Rev-Up',
    missions: [
      {
        name: 'Mission #1',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #2',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #3',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #4',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
    ],
  },
  {
    name: 'Engaged',
    missions: [
      {
        name: 'Mission #1',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #2',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #3',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #4',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
    ],
  },
  {
    name: 'Re-Engage',
    missions: [
      {
        name: 'Mission #1',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #2',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #3',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
      {
        name: 'Mission #4',
        emails: ['Email #1', 'Email #2', 'Email #3', 'Email #4', 'Email #5'],
      },
    ],
  },
]

function descendingComparator(a, b, orderBy): number {
  const aCompare = String(a?.[orderBy]).toLowerCase() || ''
  const bCompare = String(b?.[orderBy]).toLowerCase() || ''

  // Kept Commented for now, may be useful in future
  if (orderBy === 'status') {
    let aDate: any
    let bDate: any
    if (a[orderBy].toLowerCase() === 'email scheduled' || a[orderBy].toLowerCase() === 'active') {
      aDate = a?.sendDates?.length > 0 ? new Date(a?.sendDates?.[0]?.[1]) : undefined
    }

    if (b[orderBy].toLowerCase() === 'email scheduled' || b[orderBy].toLowerCase() === 'active') {
      bDate = b?.sendDates?.length > 0 ? new Date(b?.sendDates?.[0]?.[1]) : undefined
    }

    const statusComparison = String(String(a.status).toLowerCase()).localeCompare(
      String(b.status).toLowerCase(),
    )
    // If status is the same, compare dates
    if (statusComparison === 0) {
      let returnValue: any = statusComparison
      returnValue = aDate - bDate
      return returnValue
    }

    return statusComparison
  }

  if (a && b && bCompare < aCompare) {
    return -1
  }
  if (a && b && bCompare > aCompare) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

const Filters = {
  status: [
    { value: 'All', label: 'All' },
    { value: 'new', label: 'New' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'active', label: 'Active' },
    { value: 'replied', label: 'Replied' },
    { value: 'no-action', label: 'No Action' },
    { value: 'marketing', label: '@Marketing' },
    { value: 'do-not-contact', label: 'Do Not Engage' },
  ],
  rank: ['All', ...ranks],
  addedBy: [
    { value: 'All', label: 'All' },
    { value: 'maverick', label: 'Maverick App' },
    { value: 'user', label: 'User' },
  ],
  maneuver: [
    { value: 'All', label: 'All' },
    { value: 'rev-up', label: 'Rev-Up' },
    { value: 'engaged', label: 'Engaged' },
    { value: 're-engage', label: 'Re-Engage' },
  ],
}
const noActionTypes = ['Mission Complete', '30 day', '60 day', '90 day', '120 day', '6+ months']

const Contacts: FC<Props> = ({
  prospects,
  search,
  currentUser,
  setCurrentUser,
  setTypeProp,
  SidebarExpanded,
  setSidebarExpanded,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [openActions, setOpenActions] = useState(false)
  const [openExport, setOpenExport] = useState(false)
  const anchorExportRef = useRef<HTMLButtonElement>(null)
  const [orderBy, setOrderBy] = useState('name')
  const [order, setOrder] = useState<Order>('asc')
  const [rowsPerPage, setRowsPerPage] = useState(50)
  const [page, setPage] = useState(0)

  const [selectedItems, setselectedItems] = useState({})
  const [selectedLeadsDetailed, setselectedLeadsDetailed] = useState<any>([])
  const [selectedItemCount, setselectedItemCount] = useState(0)

  const searchResults: any = search?.filteredProspects

  const handleFilterChange = (key, value) => {
    // eslint-disable-next-line prefer-const
    let data: any = { ...search?.selectedFilter }
    data[key] = value
    search?.setSelectedFilter(data)
  }

  const getSelectedData = () => {
    return search?.filteredProspects?.filter(item => selectedItems[item?.id])
  }

  useEffect(() => {
    const selectedCount = Object.keys(selectedItems)?.length
    setselectedItemCount(selectedCount)
    setOpenActions(selectedCount > 1)
    setselectedLeadsDetailed(getSelectedData())
  }, [selectedItems])

  useEffect(() => {
    setselectedItems({})
  }, [search?.prospects])

  const [tableData, settableData] = useState<any>([])

  useEffect(() => {
    let data = search?.filterProspects ? [...search?.filteredProspects] : []
    if (order && orderBy) {
      if (rowsPerPage > 0) {
        data = stableSort(data, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage,
        )
      }
    }
    settableData(data)
  }, [search?.filteredProspects, order, orderBy, rowsPerPage, page])

  const formatCheckList = (): void => {
    setselectedItems({})
    setIsSelectAll(false)
  }

  const handleSelectAll = () => {
    // eslint-disable-next-line prefer-const
    let dataObj = {}
    if (!isSelectAll) {
      tableData?.map(item => {
        dataObj[item?.id] = true
      })
    }
    setselectedItems(dataObj)
    setIsSelectAll(old => !old)
  }

  const exportHangar = async (results: Prospect[] | undefined): Promise<void> => {
    const myInit = { body: results }

    try {
      await API.post('mav-outlook-api', '/leads/export', myInit)

      search?.pushToToasts({
        type: ToastTypeEnum.INFO,
        message: 'Your report will be emailed to you shortly',
      })
      setOpenExport(old => !old)
    } catch (e) {
      console.error(e)

      prospects?.setIsLoading(false)
    }
  }

  const exportSelectedHangar = async (): Promise<void> => {
    setIsLoading(true)
    const data: any = getSelectedData()
    await exportHangar(data)
    setIsLoading(false)
  }

  function handleListKeyDown(event: React.KeyboardEvent): void {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpenExport(false)
    }
  }

  // Filter By Mission Name
  const [MissionNameOptions, setMissionNameOptions] = useState<string[]>([])

  useEffect(() => {
    const options: string[] = []
    search?.prospects?.forEach((item: any): void => {
      if (item.missionName && !options.includes(item.missionName)) {
        options.push(item.missionName)
      }
    })
    if (options !== MissionNameOptions) {
      options.sort()

      // Remove Current Mission from Mission names
      const currentMissionIndex = options.indexOf('Current Mission')
      if (currentMissionIndex !== -1) {
        options.splice(currentMissionIndex, 1)
      }

      setMissionNameOptions(options)
    }
  }, [search?.prospects])

  const handleActionsExportClose = (event?: React.MouseEvent<EventTarget>): void => {
    if (anchorExportRef.current && anchorExportRef.current.contains(event?.target as HTMLElement)) {
      return
    }
    setOpenExport(false)
  }

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ): void => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <div className="contacts">
      <div className="contacts-body">
        <div className="email-type">
          <div className="contacts-body-header">
            <div className="highlights">
              <FaUserAlt className="user-icon" />
              <p className="title">CONTACTS</p>
              <Divider orientation="vertical" flexItem />

              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {/* is Hot */}
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={search?.selectedFilter?.isHot}
                        onChange={(e: any, value: any) => handleFilterChange('isHot', value)}
                        color="default"
                      />
                    }
                    label="Hot"
                    color="default"
                  />
                </FormGroup>

                {/* Status */}
                <FormControl size="small" style={{ minWidth: 150 }} variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status"
                    label="status"
                    displayEmpty
                    value={search?.selectedFilter?.status}
                    onChange={(e: any) => {
                      handleFilterChange('status', e.target.value)
                    }}
                  >
                    {Filters?.status?.map(item => (
                      <MenuItem value={item?.value}>{item?.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Maneuver */}
                <FormControl size="small" style={{ minWidth: 150 }} variant="outlined">
                  <InputLabel id="Maneuver-label">Maneuver</InputLabel>
                  <Select
                    labelId="Maneuver-label"
                    id="Maneuver-label"
                    label="Maneuver"
                    displayEmpty
                    value={search?.selectedFilter?.maneuver}
                    onChange={(e: any) => {
                      handleFilterChange('maneuver', e.target.value)
                    }}
                    placeholder="Select Mission"
                  >
                    {Filters?.maneuver?.map(item => (
                      <MenuItem value={item?.value}>{item?.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Mission */}
                <FormControl size="small" style={{ minWidth: 150 }} variant="outlined">
                  <InputLabel id="mission-name-label">Mission Name</InputLabel>
                  <Select
                    labelId="mission-name-label"
                    id="mission-name-label"
                    label="Mission Name"
                    displayEmpty
                    value={search?.selectedFilter?.missionName}
                    onChange={(e: any) => {
                      handleFilterChange('missionName', e.target.value)
                    }}
                    placeholder="Select Mission"
                  >
                    <MenuItem value="All">All Missions</MenuItem>
                    {MissionNameOptions?.map(item => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* rank */}
                <FormControl size="small" style={{ minWidth: 150 }} variant="outlined">
                  <InputLabel id="rank-label">Rank</InputLabel>
                  <Select
                    labelId="rank-label"
                    id="rank"
                    label="rank"
                    displayEmpty
                    value={search?.selectedFilter?.rank}
                    onChange={(e: any) => {
                      handleFilterChange('rank', e.target.value)
                    }}
                  >
                    {Filters.rank?.map(item => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Added By */}
                <FormControl size="small" style={{ minWidth: 150 }} variant="outlined">
                  <InputLabel id="addedBy-label">Added By</InputLabel>
                  <Select
                    labelId="addedBy-label"
                    id="addedBy"
                    label="addedBy"
                    displayEmpty
                    value={search?.selectedFilter?.addedBy}
                    onChange={(e: any) => {
                      handleFilterChange('addedBy', e.target.value)
                    }}
                  >
                    {Filters.addedBy?.map(item => (
                      <MenuItem value={item?.value}>{item?.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {search?.isDataFiltered ? (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                  <div onClick={(): void => search?.resetFilters()} className="cursor-pointer">
                    <CloseRounded />
                    Clear Filter
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {search?.selectedFilter?.status === 'no-action' && (
          <div className="email-type ">
            <div className="highlights">
              {noActionTypes.map(item => (
                // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                <div
                  role="button"
                  className={`highlight ${
                    search?.selectedFilter?.noSelectedFilter === item ? 'active' : ''
                  }`}
                  key={`emailTypeOption - ${item}`}
                  onClick={(): void =>
                    handleFilterChange(
                      'noSelectedFilter',
                      search?.selectedFilter?.noSelectedFilter === item ? null : item,
                    )
                  }
                  onKeyDown={(): void => {}}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="email-type ">
          <div className="highlights">
            <CircleCheckbox
              name={`${isSelectAll ? 'UNSELECT' : 'SELECT'} ALL CONTACTS ${
                selectedItemCount ? `(${selectedItemCount} Selected) ` : ''
              }`}
              state={isSelectAll}
              onChangeState={handleSelectAll}
            />
            <Divider orientation="vertical" flexItem />
            <div className="search-container">
              <FaSearch className="search-icon" />
              <BootStrapFormControl
                autoFocus
                type="text"
                min={1}
                placeholder="Company, Email, Industry, Name, Title"
                value={search?.searchQuery}
                className="custom-day"
                onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                  const { value } = e.currentTarget
                  search?.onChangeQuery(value)
                  formatCheckList()
                }}
              />
            </div>
            <Divider orientation="vertical" flexItem />
            <div className="contacts-filter">
              FULL LIST
              <Button
                ref={anchorExportRef}
                aria-controls={openExport ? 'menu-list-action' : undefined}
                aria-haspopup="true"
                onClick={(): Promise<void> => exportHangar(searchResults)}
              >
                <FaFileExport className="filter-icon" />
              </Button>
              <Divider orientation="vertical" flexItem />
              SELECTED
              <Button
                ref={anchorExportRef}
                aria-controls={openExport ? 'menu-list-action' : undefined}
                aria-haspopup="true"
                onClick={() => exportSelectedHangar()}
              >
                <FaFileExport className="filter-icon" />
              </Button>
              <Popper
                open={openExport}
                anchorEl={anchorExportRef.current}
                role={undefined}
                transition
                disablePortal
                style={{
                  zIndex: 1,
                  overflow: 'auto',
                  maxHeight: 500,
                  border: '2px solid #59595b',
                  width: 300,
                }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleActionsExportClose}>
                        <MenuList
                          autoFocusItem={openExport}
                          id="menu-list-action"
                          onKeyDown={handleListKeyDown}
                          style={{ padding: 0 }}
                        >
                          <div className="actions-header export">
                            <p className="popup-menu-header">
                              A .csv file is being assembled. Check your Inbox for a link to
                              download and save it.
                            </p>
                            <FaTimes onClick={handleActionsExportClose} />
                          </div>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                count={searchResults.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                onPageChange={handleChangePage}
              />
            </TableRow>
          </div>
        </div>
        {search?.isLoading || isLoading ? (
          <Spinner />
        ) : (
          <div className="users-container ">
            {openActions ? (
              <BulkLeadActions
                setIsLoading={setIsLoading}
                leadsToBeUpdated={selectedLeadsDetailed}
                setOpenActions={setOpenActions}
                openActions={openActions}
                isLoading={isLoading}
              />
            ) : null}
            <ContactTable
              search={search}
              data={tableData}
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              setTypeProp={setTypeProp}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              order={order}
              setOrder={setOrder}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              setPage={setPage}
              setIsSelectAll={setIsSelectAll}
              SidebarExpanded={SidebarExpanded}
              setSidebarExpanded={setSidebarExpanded}
              setselectedItems={setselectedItems}
              selectedItems={selectedItems}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default inject('prospects', 'search')(withRouter(observer(Contacts)))
